import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiXCircle } = FiIcons;

const PaymentCancel = () => {
  return (
    <div className="flex items-center justify-center min-h-full p-6 bg-gray-50">
      <motion.div
        className="max-w-md w-full bg-white p-8 rounded-xl shadow-lg text-center"
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5, type: 'spring' }}
      >
        <div className="mx-auto flex items-center justify-center h-20 w-20 rounded-full bg-red-100 mb-6">
          <SafeIcon icon={FiXCircle} className="h-12 w-12 text-red-600" />
        </div>
        <h2 className="text-2xl font-bold text-gray-900 mb-2">Payment Canceled</h2>
        <p className="text-gray-600 mb-8">
          Your payment process was canceled. You can try again from the invoice page.
        </p>
        <Link to="/invoices">
          <motion.button
            className="w-full bg-gray-600 text-white py-3 px-6 rounded-lg font-semibold hover:bg-gray-700 transition-colors"
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.95 }}
          >
            Back to Invoices
          </motion.button>
        </Link>
      </motion.div>
    </div>
  );
};

export default PaymentCancel;